/* eslint-disable */
import createTheme from "@mui/material/styles/createTheme";
const pallete = {
  primary: {
    main: "rgba(0, 77, 74, 1)",
    light: "rgba(221, 235, 215, 1)",
    dark: "rgba(0, 26, 24, 1)"
  },
  secondary: {
    main: "#545e46",
    light: "#bbbfb5",
    dark: "#22261c"
  },
  success: {
    main: "#71A054",
    light: "#9cbd87",
    dark: "#39502a"
  },

  error: {
    main: "#CF4545",
    light: "#d45858",
    dark: "#A92222;"
  },
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.6)",
    disabled: "rgba(0, 0, 0, 0.38)",
    success: "#71A054"
  }
};
const theme = createTheme({
  palette: pallete,
  typography: {
    htmlFontSize: 18,
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    fontSize: 16,

    h1: {
      fontWeight: 500,
      fontSize: "2.5rem",
      lineHeight: "1.125rem",
      letterSpacing: "-0.01562em",
      "@media (max-width: 730px)": {
        lineHeight: "2.5rem"
      }
    },

    h5: {
      fontSize: "1.875rem",
      lineHeight: "1.25rem"
    },
    h6: {
      fontSize: "1.5rem",
      fontWeight: "500",
      lineHeight: "normal"
    },
    subtitle1: {
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
      fontSize: "0.75rem",
      fontWeight: 500,
      lineHeight: "1.25rem"
    },
    subtitle2: {
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
      fontSize: "0.625rem",
      lineHeight: "1.25rem"
    },
    body1: {
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
      fontSize: "1rem",
      fontWeight: 340,
      lineHeight: "1.26rem"
    },

    summaryCardTitle: {
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
      fontSize: "0.875rem",
      fontWeight: "600",
      lineHeight: "1.25rem"
    },
    reportCardTitle: {
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
      fontSize: "1rem",
      fontWeight: "600",
      lineHeight: "1.25rem"
    },
    buttonText: {
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
      fontSize: "0.875rem",
      fontWeight: "600"
    },
    caption: {
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
      fontSize: "0.85rem",
      lineHeight: "1.125rem"
    },
    formLabel: {
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
      fontSize: "0.75rem"
    },
    LayoutHeading: {
      fontSize: "1.25rem",
      fontWeight: "500",
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
      lineHeight: "1.25rem"
    }
  }
});

export default theme;
